import { getActiveCompset, storeActiveCompset } from '@/helpers/localStorageHandlers';
import { compsetServices } from '@/services/dashboard.service';
import { queryKeys } from '@/services/queryKeyFactory';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { apiClient } from '@/services/apiClient';
import { API_URLS } from '@/constants/urls';
import { formatDateYMD } from '@/helpers/formatters';
import { apiErrorHandler } from '@/helpers/apiErrorHandler';

export const CompsetContext = React.createContext();

function CompsetProvider({ children }) {

    const { isAuthenticated } = useAuth();
    const queryClient = useQueryClient();

    const [editingCompset, setEditingCompset] = useState(null);

    // for compset edit purpose
    const [client, setClient] = useState(null);
    const [compHotels, setCompHotels] = useState([]);

    const [activeCompset, setActiveCompset] = useState(null);

    //active compset compsetitors for filtering purpose 
    const [competitors, setComptitors] = useState([]);

    const { data: compsets, isError: isErrorCompsets, isLoading: isLoadingCompsets, error } = useQuery({
        queryKey: queryKeys.compsets(),
        queryFn: compsetServices.getCompsets,
        enabled: !!isAuthenticated && !!isAuthenticated?.authStatus && isAuthenticated?.status === "ACTIVE"
    })

    async function onSuccessfullCompsetRun(compset) {
        try {

            // await queryClient.invalidateQueries({
            //     queryKey: queryKeys.compsets()
            // })

            // /hererrererere

            setActiveCompset(compset)
            queryKeys.analyticsKeys(compset?.compset_id).forEach(key => {
                queryClient.invalidateQueries({
                    queryKey: key
                })
            })

        } catch (error) {
            console.error(error)
        }
    }

    async function runCompset(date, compId, compName) {
        try {
            await apiClient.post(API_URLS.RUN_COMPSET, {
                start_date: formatDateYMD(date),
                r_id: compId,
                r_name: compName
            })

            return true
        } catch (error) {
            apiErrorHandler(error)
            return false
        }
    }

    const value = {
        compsets,
        client,
        setClient,
        compHotels,
        setCompHotels,
        isErrorCompsets,
        isLoadingCompsets,
        activeCompset,
        setActiveCompset,
        competitors,
        error,
        runCompset,
        onSuccessfullCompsetRun,
        // added
        editingCompset,
        setEditingCompset,
    }


    useEffect(() => {

        if (isLoadingCompsets || isErrorCompsets || !compsets) return;

        // let activeCompset = getActiveCompset();

        // if (typeof activeCompset === "string") {
        //     activeCompset = JSON.parse(activeCompset);
        // }

        // const isExist = compsets?.user_compsets?.find(
        //     comp => comp?.compset_id == activeCompset?.compset_id
        // );

        // if (!activeCompset || !isExist) {
        //     activeCompset = compsets?.user_compsets?.find(
        //         compset => compset?.is_active
        //     );

        //     if (activeCompset) {
        //         storeActiveCompset(JSON.stringify(activeCompset));
        //     }

        // }

        let activeCompset = compsets?.user_compsets?.find(
            compset => compset?.is_active
        );

        if (activeCompset) {
            setActiveCompset(activeCompset);
        }

    }, [isLoadingCompsets, isErrorCompsets, compsets]);

    useEffect(() => {
        if (!activeCompset) return
        setComptitors(activeCompset?.competitors)
    }, [activeCompset])

    return (
        <CompsetContext.Provider value={value}>
            {children}
        </CompsetContext.Provider>
    );
}

export const useCompset = () => {
    const context = useContext(CompsetContext);
    if (!context) {
        throw new Error("useCompset must be used within CompsetProvider");
    }
    return context
}

export default CompsetProvider;